import React, { ReactNode } from 'react';
import { tokens } from '@companycam/slab';
import styled from 'styled-components';
import ValuePropsChecklist, {
  ValuePropsChecklistProps,
} from './ValuePropsChecklist';

const Title = styled.h1`
  font-size: ${tokens.size_text_xxxl}px;
  font-weight: 800;
  line-height: 1em;
  margin-top: ${tokens.size_spacing_l}px;
  width: 80%;
  color: ${tokens.color_text_default_le};
  font-family: 'Averta', system-ui, sans-serif;
`;

const Description = styled.h2`
  display: flex;
  font-size: 16px;
  font-weight: 600;
  margin-top: 12px;
  line-height: 1.25em;
  color: ${tokens.color_text_default_le};
`;

export type ValuePropsContentProps = {
  title: string | ReactNode;
  description: string | ReactNode;
  items: ValuePropsChecklistProps['checklistItems'];
};

const ValuePropsContent = ({
  title,
  description,
  items,
}: ValuePropsContentProps) => (
  <>
    <Title>{title}</Title>
    <Description>{description}</Description>
    <ValuePropsChecklist checklistItems={items} />
  </>
);

export default ValuePropsContent;
